import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import useWebView from "@hooks/useWebview";
import { trackEvents } from "@/common/events/events";
var OIL_PAYMENT_SUMMARY_KEY = "oil_cart_payment_summary";
var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "28",
    stroke: "#12B76A",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 33L28 42L45 22",
    stroke: "#12B76A",
    strokeWidth: "3.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var StepCard = function StepCard(_ref) {
  var stepNum = _ref.stepNum,
    label = _ref.label,
    borderColor = _ref.borderColor,
    gradientEnd = _ref.gradientEnd;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex-1 relative rounded-[8px] min-h-[72px] overflow-visible",
    style: {
      border: "0.2px solid ".concat(borderColor),
      filter: "drop-shadow(0px 1px 1px rgba(0,0,0,0.08))"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-full min-h-[72px] rounded-[8px] flex items-center justify-center px-2 py-3",
    style: {
      background: "linear-gradient(237deg, #fff 14%, ".concat(gradientEnd, " 100%)")
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#020202] font-bold text-[14px] leading-5 text-center w-full",
    dir: "auto"
  }, label)), /*#__PURE__*/React.createElement("div", {
    className: "absolute -top-5 left-0 rtl:-right-1 w-8 h-8 rounded-full bg-[#fbfbfb] border border-[rgba(251,251,251,0.1)] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08)] flex items-center justify-center z-10 overflow-hidden"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#020202] font-medium text-[16px] leading-none"
  }, stepNum)));
};
var OilPaymentSuccess = function OilPaymentSuccess() {
  var _useTranslation = useTranslation(["web_oils"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var webview = useWebView();
  useEffect(function () {
    document.cookie = "cart_id=; path=/; max-age=0";
    webview.onCartPaymentSuccess();
    if (__IS_CSR__) {
      var _params$get, _ref2, _summary$order_id, _summary$products_cou, _summary$total_quanti, _summary$total_amount, _summary$payment_meth;
      var params = new URLSearchParams(window.location.search);
      var sourceType = (_params$get = params.get("source_type")) !== null && _params$get !== void 0 ? _params$get : "";
      var paymentMethod = sourceType === "applepay" ? "apple_pay" : "visa";
      var stored = localStorage.getItem(OIL_PAYMENT_SUMMARY_KEY);
      var summary = stored ? JSON.parse(stored) : {};
      trackEvents("vas_payment_success", {
        order_id: (_ref2 = (_summary$order_id = summary.order_id) !== null && _summary$order_id !== void 0 ? _summary$order_id : params.get("id")) !== null && _ref2 !== void 0 ? _ref2 : "",
        products_count: (_summary$products_cou = summary.products_count) !== null && _summary$products_cou !== void 0 ? _summary$products_cou : 0,
        total_quantity: (_summary$total_quanti = summary.total_quantity) !== null && _summary$total_quanti !== void 0 ? _summary$total_quanti : 0,
        total_amount: (_summary$total_amount = summary.total_amount) !== null && _summary$total_amount !== void 0 ? _summary$total_amount : 0,
        payment_method: (_summary$payment_meth = summary.payment_method) !== null && _summary$payment_meth !== void 0 ? _summary$payment_meth : paymentMethod
      });
      localStorage.removeItem(OIL_PAYMENT_SUMMARY_KEY);
    }
  }, []);
  var handleOrderDetails = function handleOrderDetails() {
    trackEvents("order_tracking_entry", {
      referral_location: "service_payment_success"
    });
    navigateToHard("/tracking-landing?tab=car_services");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white border border-[#ebf0f7] rounded-2xl shadow-[0px_1px_1px_rgba(0,0,0,0.08)] py-10 px-2 md:p-10 flex flex-col items-center gap-12 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-6 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#e6f7ef] p-2 rounded-2xl flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(CheckIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-3 text-center"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-[#00143c] font-bold text-[24px] leading-8"
  }, tShort("payment_status/success_title", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6c7a8d] text-[18px] leading-7 tracking-[-0.45px]"
  }, tShort("payment_status/success_subtitle", {
    ns: "web_oils"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 w-full mt-4"
  }, /*#__PURE__*/React.createElement(StepCard, {
    stepNum: 1,
    label: tShort("payment_status/step1_text", {
      ns: "web_oils"
    }),
    borderColor: "#ffdace",
    gradientEnd: "#FFD7C9"
  }), /*#__PURE__*/React.createElement(StepCard, {
    stepNum: 2,
    label: tShort("payment_status/step2_text", {
      ns: "web_oils"
    }),
    borderColor: "#b9e5fd",
    gradientEnd: "#B9E5FD"
  }), /*#__PURE__*/React.createElement(StepCard, {
    stepNum: 3,
    label: tShort("payment_status/step3_text", {
      ns: "web_oils"
    }),
    borderColor: "#e6f7ef",
    gradientEnd: "#96E0BF"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6c7a8d] text-[12px] leading-4 text-center tracking-[-0.3px] w-full"
  }, tShort("payment_status/steps_note", {
    ns: "web_oils"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("button", {
    className: "w-full border-none bg-primary-new text-white font-bold text-[16px] leading-6 rounded-[4px] py-3 px-4 cursor-pointer",
    onClick: handleOrderDetails
  }, tShort("payment_status/order_details", {
    ns: "web_oils"
  }))));
};
export default OilPaymentSuccess;